import {commonConfirmationBulkDelete} from "../../../../hoc/commonConfirmationBulkDelete";

const BulkSaleDelete = commonConfirmationBulkDelete("BulkSaleDelete")
export default BulkSaleDelete
